import styled from 'styled-components'
import { Button } from '~/components/shared'
import { message } from '~/services'

export const Form = styled.form`
  position: relative;
  padding: 0 2rem;
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const DynamicFormFields = styled.div<{ show: boolean }>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  opacity: ${({ show }) => (show ? 1 : 0)};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  transition: opacity 0.2s ease-in-out;
`

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const ContainerLabels = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
`

export const LabelSpan = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Disclaimer = styled.p`
  color: ${props => props.theme.colors.color545e6c};
  font-family: 'Inter';
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.75rem;
`

export const FlexLabel = styled.label`
  display: flex;
  gap: 1rem;
  align-items: center;

  * {
    cursor: pointer;
    margin: 0;
  }
`

export const ReturnButton = styled(Button).attrs(props => ({
  ...props,
  minWidth: 'medium',
  variant: 'outlined',
  children: message('feedback.return_label')
}))``

export const SubmitButton = styled(Button).attrs(props => ({
  ...props,
  type: 'submit',
  minWidth: 'medium',
  children: message('feedback.submit_label')
}))``
